// (A) 중립 표면 — antd 완전 제거(D4-2). OmwKitThemeHost 로 직결.
// OmwPalette 를 :root 의 `--om-*` CSS 변수로 주입(portal 포함 전역). 컴포넌트는 var(--om-*) 로 소비.
// confirmDefaults: 명령형 Modal.confirm 의 기본 OK/Cancel 텍스트(owma i18next 공급). kit 은 i18n 미보유.
import { useEffect, type ReactNode } from 'react'
import { OmwKitThemeHost } from '../_impl/OmwKitThemeHost'
import type { ConfirmDefaults } from '../_impl/DialogStack'
import { owmaPalette, paletteCssVars, type OmwPalette } from './tokens'

export interface OmwThemeProviderProps {
  palette?: OmwPalette
  // 명령형 Modal.confirm 기본 버튼 텍스트(로케일 반영). owma localization 이 i18next 로 공급.
  confirmDefaults?: ConfirmDefaults
  children: ReactNode
}

// 앱 루트에 한 번 감싼다. palette 는 :root 에 `--om-*` 로 주입.
export function OmwThemeProvider({
  palette = owmaPalette,
  confirmDefaults,
  children,
}: OmwThemeProviderProps) {
  useEffect(() => {
    const root = document.documentElement
    const vars = paletteCssVars(palette)
    for (const [k, v] of Object.entries(vars)) root.style.setProperty(k, v)
    return () => {
      for (const k of Object.keys(vars)) root.style.removeProperty(k)
    }
  }, [palette])

  return <OmwKitThemeHost confirmDefaults={confirmDefaults}>{children}</OmwKitThemeHost>
}
